













import { defineComponent, ref } from "@vue/composition-api";
import { InputReviewCreate, ReviewSubjectType } from "@scrile/api-provider/dist/api/ReviewProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import { handleRequestError } from "@/lib/handleRequestError";
import { ERRORS } from "@/const";
import RestrictedWordConfirm from "@/components/RestrictedWordConfirm";
import { extractRestrictedWords } from "@/components/RestrictedWordConfirm/helpers";
import ReviewInput from "./ReviewInput.vue";

const REVIEW_RATING_PLACEHOLDER = 0;

export default defineComponent({
  name: "ReviewsSendController",
  components: { RestrictedWordConfirm, ReviewInput },
  props: {
    postId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const comment = ref<string>("");
    const sending = ref(false);
    const removing = ref(false);
    const showRestrictedWordConfirm = ref(false);
    const restrictedWords = ref<string[]>([]);

    const sendReview = useAuthorisedOnly(async (cb: () => void) => {
      try {
        sending.value = true;
        const newReview: InputReviewCreate = {
          subject: {
            subjectId: props.postId,
            subjectType: ReviewSubjectType.POST,
          },
          rating: REVIEW_RATING_PLACEHOLDER,
          comment: comment.value.trim(),
        };
        providers.ReviewProvider.setReceiveErrors(false);
        const review = await providers.ReviewProvider.create({ data: newReview });
        emit("sent", review);
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === ERRORS.RESTRICTED_WORD,
            onSuccessCB: e => {
              restrictedWords.value = extractRestrictedWords(e);
              showRestrictedWordConfirm.value = true;
            },
          },
        ]);
      } finally {
        cb();
        sending.value = false;
        comment.value = "";
      }
    });

    const removeReview = useAuthorisedOnly(async (id: string, cb: () => void) => {
      try {
        removing.value = true;
        await providers.ReviewProvider.delete({ reviewId: id });
        emit("remove", id);
        cb();
      } finally {
        removing.value = false;
      }
    });

    const setComment = (username: string) => {
      comment.value = comment.value.replace(/^@[a-z0-9_.-]+/gi, "");
      comment.value = comment.value.replace(/^, /gi, "");
      comment.value = `${username}, ${comment.value}`;
    };

    return {
      comment,
      sendReview,
      removeReview,
      removing,
      showRestrictedWordConfirm,
      restrictedWords,
      setComment,
    };
  },
});
